export const environment = {
  production: true,
  apiUrl: 'https://techsurance-api.clevernav.ai'
};
